import moment from 'moment'

export default {
  filters: {
    formatDate (val){
      return moment(val).format('MMM DD YYYY - H:mm')
    }
  }
}